import React, { useState, useEffect } from 'react';
import './PaymentModal.css';

const PaymentModal = ({ address, qrCode, amount, creditsToAdd, isDeposit = false, onClose }) => {
  const [copied, setCopied] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(300); // 5 minutes

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(address);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-window win98-bevel" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{isDeposit ? '💳 Deposit DOGE' : '💰 Payment Required 💰'}</h2>
          <button onClick={onClose} className="close-button win98-button">✕</button>
        </div>

        <div className="modal-content">
          <div className="payment-info">
            {isDeposit ? (
              <>
                <p className="payment-instruction">
                  Send <strong>exactly {amount.toFixed(8)} DOGE</strong> to deposit and receive <strong>{creditsToAdd.toFixed(2)} Credits</strong>.
                  This amount includes estimated network and processing fees so the full 20 DOGE can go into the daily prize pool.
                </p>
                <div className="credits-info win98-bevel-inset">
                  <strong>Deposit Details:</strong>
                  <p>💰 Deposit Amount: {amount.toFixed(8)} DOGE (fees included)</p>
                  <p>🎁 Credits: {creditsToAdd.toFixed(2)} Credits (1 Credit = 1 DOGE of prize power)</p>
                  <p>💬 Messages: You can send {creditsToAdd.toFixed(0)} messages with this deposit!</p>
                </div>
              </>
            ) : (
              <p className="payment-instruction">
                Send <strong>exactly {amount.toFixed(8)} DOGE</strong> to the address below to post your message:
              </p>
            )}
          </div>

          <div className="qr-section">
            <div className="qr-code-container win98-bevel-inset">
              {qrCode ? (
                <img src={qrCode} alt="Payment QR Code" style={{ width: '200px', height: '200px' }} />
              ) : (
                <div style={{ width: '200px', height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  Loading QR Code...
                </div>
              )}
            </div>
          </div>

          <div className="address-section">
            <label>Payment Address:</label>
            <div className="address-input-container">
              <input
                type="text"
                value={address}
                readOnly
                className="address-input win98-bevel-inset"
              />
              <button
                onClick={copyToClipboard}
                className="win98-button copy-button"
              >
                {copied ? '✓ Copied!' : '📋 Copy'}
              </button>
            </div>
          </div>

          <div className="timer-section">
            <p className="timer-text">
              ⏰ Time remaining: <strong>{formatTime(timeRemaining)}</strong>
            </p>
            {timeRemaining === 0 && (
              <p className="timer-expired">Payment window expired. Please try again.</p>
            )}
          </div>

          <div className="payment-note">
            <p>⚠️ Important:</p>
            <ul>
              {isDeposit ? (
                <>
                  <li>Send exactly {amount.toFixed(8)} DOGE (this includes estimated fees)</li>
                  <li><strong>Why {amount.toFixed(1)} DOGE instead of {creditsToAdd.toFixed(0)}?</strong> NOWPayments charges processing and network fees. The extra amount covers these fees so the full {creditsToAdd.toFixed(0)} DOGE can go into the daily prize pool!</li>
                  <li>You'll receive {creditsToAdd.toFixed(2)} Credits (each Credit represents 1 DOGE in the daily prize pool)</li>
                  <li>Credits will be added automatically once payment is confirmed</li>
                  <li>This usually takes 1-2 minutes</li>
                  <li>You can close this window - your deposit will still be processed</li>
                </>
              ) : (
                <>
                  <li>Send exactly {amount.toFixed(8)} DOGE (not more, not less)</li>
                  <li>Your message will appear automatically once payment is confirmed</li>
                  <li>This usually takes 1-2 minutes</li>
                  <li>You can close this window - your payment will still be processed</li>
                </>
              )}
            </ul>
          </div>
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="win98-button">
            Close ({isDeposit ? 'Deposit' : 'Payment'} will still process)
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
